<template>
    <div id="app" class="app">
        <RouterView />
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { RouterView } from 'vue-router'

export default defineComponent({
    name: 'App',
    components: {
        RouterView
    }
})
</script>

<style lang="scss">
@use './scss/variables' as *;

.app {
    min-height: 100vh;
    background-color: $color-background-primary;
    color: $color-text-primary;
    font-family: 'FixelText', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif;
}
</style>